import { render, staticRenderFns } from "./ChangePasswordComplete.vue?vue&type=template&id=9c773bfe&scoped=true"
import script from "./ChangePasswordComplete.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordComplete.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordComplete.vue?vue&type=style&index=0&id=9c773bfe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c773bfe",
  null
  
)

export default component.exports